export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST'
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE'

export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST'
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE'

export const ADD_PROJECT_REQUEST="ADD_PROJECT_REQUEST"
export const ADD_PROJECT_SUCCESSFULL="ADD_PROJECT_SUCCESSFULL"
export const ADD_PROJECT_FAILURE="ADD_PROJECT_FAILURE"

export const UPDATE_PROJECT_REQUEST="UPDATE_PROJECT_REQUEST"
export const UPDATE_PROJECT_SUCCESS="UPDATE_PROJECT_SUCCESS"
export const UPDATE_PROJECT_FAILURE="UPDATE_PROJECT_FAILURE"

export const GET_PROJECTS_REQUEST="GET_PROJECTS_REQUEST"
export const GET_PROJECTS_SUCCESSFULL="GET_PROJECTS_SUCCESSFULL"
export const GET_PROJECTS_FAILURE="GET_PROJECTS_FAILURE"

export const DELETE_PROJECT_REQUEST="DELETE_PROJECT_REQUEST"
export const DELETE_PROJECT_SUCCESS="DELETE_PROJECT_SUCCESS"
export const DELETE_PROJECT_FAILURE="DELETE_PROJECT_FAILURE"